import React, { useState } from 'react';
import './App.css';
import CaseStudies from './components/CaseStudies';
import AIProjects from './components/AIProjects';
import Contact from './components/Contact';
import AIProjectModal from './components/AIProjectModal';

function App() {
  const [activeTab, setActiveTab] = useState('home');
  const [showAIPortfolioModal, setShowAIPortfolioModal] = useState(false);
  
  const aiPortfolioProject = {
    id: 1,
    title: "AI-Assisted Portfolio Development",
    content: {
      overview: {
        title: "Project Overview",
        text: "I built this website with Cursor, utilizing collaborative coding with Claude 3.5 Sonnet, an Anthropic LLM. The project demonstrates how AI can be effectively used as a programming partner while maintaining full developer control over architecture and design decisions."
      },
      technical: {
        title: "Technical Implementation",
        text: "Built with React and modern CSS, the site features responsive design, component-based architecture, and clean, maintainable code. Key features include:",
        list: [
          "Dynamic content rendering with React components",
          "Markdown-based case study system",
          "Modal windows for detailed content",
          "Responsive video embedding",
          "CSS Grid and Flexbox layouts"
        ]
      },
      process: {
        title: "AI Collaboration Process",
        text: "Claude served as a programming partner throughout development, helping with:",
        list: [
          "Code implementation and debugging",
          "CSS styling and layout solutions",
          "Component structure recommendations",
          "Best practice suggestions",
          "Real-time code reviews and improvements"
        ]
      },
      learnings: {
        title: "Key Learnings",
        text: "This project demonstrated how AI can enhance the development process while maintaining high code quality:",
        list: [
          "AI excels at suggesting implementation details while humans drive overall architecture",
          "Iterative AI collaboration enables rapid prototyping and refinement",
          "Clear communication with AI leads to better code solutions",
          "AI can help maintain consistency across a codebase",
          "Human oversight remains crucial for final design and implementation decisions"
        ]
      }
    }
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const toggleAIPortfolioModal = () => {
    setShowAIPortfolioModal(!showAIPortfolioModal);
  };

  const renderContent = () => {
    switch(activeTab) {
      case 'case-studies':
        return <CaseStudies />;
      case 'ai-projects':
        return <AIProjects />;
      case 'contact':
        return <Contact />;
      case 'home':
      default:
        return (
          <div className="home-content-wrapper">
            <div className="home-content">
              <div className="right-content">
                <div className="image-container">
                  <img
                    src={process.env.PUBLIC_URL + '/Profile_large.jpg'}
                    alt="Mimi Leinbach"
                    className="homepage-image"
                  />
                </div>
              </div>
              <div className="left-content">
                <p>I close the gap between AI potential and AI outcomes.</p>
                <p>I've built from zero three times. First, I bootstrapped Scout Kids, a children's apparel brand, to profitability in under 2 years with 250 stores across 38 states and 10 countries. Then I moved to enterprise tech, where I built the product operations and enablement function from scratch at SAP SuccessFactors. I also shipped AI features to 26M users and built consultative feedback loops with 200+ Fortune 500 executives to identify high-impact use cases and drive adoption.</p>
                <p>Now I'm building Scout Signal, focused on AI adoption and enablement. I build multi-agent AI systems with Claude Code, Cursor, and Zapier, deliver hands-on AI enablement training for teams, and develop training that drives real behavior change. I'm focused on helping organizations turn AI investment into real, measurable results.</p>
                <p>The thread across all of it: I see what's missing and build it. The human side of AI transformation is what matters most now.</p>
                <p>I built this site with Cursor using Claude as a coding assistant. <span className="learn-more" onClick={toggleAIPortfolioModal}>Learn More</span></p>
              </div>
            </div>
          </div>
        );
    }
  };

  return (
    <div className="App">
      <header className="App-header">
        <div className="header-container">
          <h1>Mimi Leinbach</h1>
          <nav className="tab-menu">
            <ul>
              <li>
                <button 
                  className={`tab-button ${activeTab === 'home' ? 'active' : ''}`}
                  onClick={() => handleTabChange('home')}
                >
                  Home
                </button>
              </li>
              <li>
                <button 
                  className={`tab-button ${activeTab === 'ai-projects' ? 'active' : ''}`}
                  onClick={() => handleTabChange('ai-projects')}
                >
                  AI Projects
                </button>
              </li>
              <li>
                <button 
                  className={`tab-button ${activeTab === 'case-studies' ? 'active' : ''}`}
                  onClick={() => handleTabChange('case-studies')}
                >
                  Case Studies
                </button>
              </li>
              <li>
                <button 
                  className={`tab-button ${activeTab === 'contact' ? 'active' : ''}`}
                  onClick={() => handleTabChange('contact')}
                >
                  Contact
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </header>
      
      <main>
        {renderContent()}
      </main>
      
      {showAIPortfolioModal && (
        <AIProjectModal 
          project={aiPortfolioProject}
          onClose={toggleAIPortfolioModal}
        />
      )}
    </div>
  );
}

export default App;
